import React from 'react';
// import Loadable from 'react-loadable';
// import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;

// if (process.env.RUNTIME_ENV !== 'browser') {
// eslint-disable-next-line global-require
Component = require('../dwen_page').default;
// }

export default function(store) {
  const routeConfig = {
    path: '/dwen',
    component() {
      // if (Component) {
      return <Component />;
      // }

      // return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import('../dwen_page').then(resp => {
        Component = resp.default;
        routeConfig.loadData = () => {};
        return Component;
      });
    },
    chunk: 'dwenPage'
  };

  // const LazyComponent = Loadable({
  //   loader() {
  //     return routeConfig.preloadChunk();
  //   },
  //   loading() {
  //     return (
  //       <section className="dwen-page">
  //         <article className="dwen-page__main">
  //           <LoadingSpinner />
  //         </article>
  //       </section>
  //     );
  //   }
  // });

  return routeConfig;
}
